<section id="login-section">
  <div id="login-container">
    <!-- Left side: Driving image (2/3) -->
    <div id="login-image-container">
      <img src="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Luxury car interior" id="login-background-image" />
      <div id="login-image-overlay">
        <div id="login-brand-section">
          <img
            src="https://mrkresz.hu/assets/shared/mrkresz-logo.png"
            alt="Mr. Kresz Logo"
            id="login-logo"
          />
          <h1 id="login-brand-title">Mr. Kresz</h1>
          <p id="login-brand-subtitle">Adminisztrációs felület</p>
        </div>
      </div>
    </div>

    <!-- Right side: Login form (1/3) -->
    <div id="login-form-container">
      <div id="login-form-content">
        <div id="login-title">
          <h2>Bejelentkezés</h2>
          <p>Adja meg bejelentkezési adatait</p>
        </div>

        <div id="login-input-fields">
          <form [formGroup]="loginForm">
            <mat-form-field appearance="outline" id="login-email-field">
              <mat-label>E-mail cím</mat-label>
              <input #emailInput matInput formControlName="loginEmailFormControl" />
            </mat-form-field>
            <mat-form-field appearance="outline" id="login-password-field">
              <mat-label>Jelszó</mat-label>
              <input
                #passwordInput
                matInput
                [type]="showPassword ? 'text' : 'password'"
                formControlName="loginPasswordFormControl"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="showPassword = !showPassword"
                tabindex="-1"
              >
                <mat-icon>
                  {{ showPassword ? "visibility" : "visibility_off" }}
                </mat-icon>
              </button>
            </mat-form-field>
          </form>
          <button
            mat-flat-button
            color="primary"
            id="login-submit"
            (click)="checkCredentials()"
          >
            Bejelentkezés
          </button>

          <div class="server-address">
            Szerver: {{ environmentService.getCurrentEnvironment().serverHost }}
          </div>
        </div>

        <div id="login-server-selector">
          <button
            mat-icon-button
            (click)="openServerSelector()"
            matTooltip="Szerver váltás"
          >
            <mat-icon>settings</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
